import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import BlogCard from './components/BlogCard';
import BlogCategories from './components/BlogCategories';
import Pagination from '../../components/common/Pagination';
import SEOHead from '../../components/SEO/SEOHead';
import defaultSEO from '../../components/SEO/seoConfig';

// Sample blog posts data
const sampleBlogPosts = [
  {
    id: 1,
    title: 'Top 10 Wildlife Experiences in Kenya',
    slug: 'top-10-wildlife-experiences-kenya',
    excerpt: 'Discover the most breathtaking wildlife encounters that Kenya has to offer, from the Great Migration to rare sightings of the Big Five.',
    content: 'Full article content here...',
    image: 'https://images.unsplash.com/photo-1523805009345-7448845a9e53?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2072&q=80',
    author: {
      name: 'Timothy Kimani',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
    },
    date: '2024-12-15',
    category: 'Wildlife',
    tags: ['safari', 'wildlife', 'big five', 'kenya']
  },
  {
    id: 2,
    title: 'A Cultural Journey Through Maasai Villages',
    slug: 'cultural-journey-maasai-villages',
    excerpt: 'Experience the rich traditions and vibrant culture of the Maasai people through immersive village visits and authentic cultural exchanges.',
    content: 'Full article content here...',
    image: 'https://images.unsplash.com/photo-1489493585363-d69421e0edd3?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
    author: {
      name: 'Sarah Njeri',
      avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
    },
    date: '2024-11-28',
    category: 'Culture',
    tags: ['maasai', 'culture', 'traditions', 'community']
  },
  {
    id: 3,
    title: 'Best Time to Visit Mount Kenya: A Seasonal Guide',
    slug: 'best-time-visit-mount-kenya-seasonal-guide',
    excerpt: 'Plan your Mount Kenya adventure with our comprehensive seasonal guide, covering weather patterns, climbing conditions, and wildlife sightings.',
    content: 'Full article content here...',
    image: 'https://images.unsplash.com/photo-1573979267151-5f4f23ae7873?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2071&q=80',
    author: {
      name: 'John Kamau',
      avatar: 'https://randomuser.me/api/portraits/men/22.jpg'
    },
    date: '2024-11-10',
    category: 'Adventure',
    tags: ['mount kenya', 'hiking', 'climbing', 'seasons']
  },
  {
    id: 4,
    title: 'Sustainable Tourism Practices in Kenya',
    slug: 'sustainable-tourism-practices-kenya',
    excerpt: 'Learn how Kenya is leading the way in sustainable tourism with eco-friendly lodges, community-based tourism initiatives, and conservation efforts.',
    content: 'Full article content here...',
    image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
    author: {
      name: 'Elizabeth Wanjiku',
      avatar: 'https://randomuser.me/api/portraits/women/28.jpg'
    },
    date: '2024-10-25',
    category: 'Conservation',
    tags: ['sustainability', 'eco-tourism', 'conservation', 'community']
  },
  {
    id: 5,
    title: 'Kenya\'s Hidden Beach Paradises',
    slug: 'kenyas-hidden-beach-paradises',
    excerpt: 'Explore Kenya\'s lesser-known coastal gems, from secluded beaches and pristine marine reserves to charming coastal villages.',
    content: 'Full article content here...',
    image: 'https://images.unsplash.com/photo-1505881502353-a1986add3762?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2072&q=80',
    author: {
      name: 'Timothy Kimani',
      avatar: 'https://randomuser.me/api/portraits/men/32.jpg'
    },
    date: '2024-10-12',
    category: 'Beaches',
    tags: ['beaches', 'coast', 'ocean', 'relaxation']
  },
  {
    id: 6,
    title: 'Safari Photography Tips for Beginners',
    slug: 'safari-photography-tips-beginners',
    excerpt: 'Capture stunning wildlife photos on your Kenya safari with these essential photography tips, equipment recommendations, and composition techniques.',
    content: 'Full article content here...',
    image: 'https://images.unsplash.com/photo-1516426122078-c23e76319801?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
    author: {
      name: 'John Kamau',
      avatar: 'https://randomuser.me/api/portraits/men/22.jpg'
    },
    date: '2024-09-30',
    category: 'Photography',
    tags: ['photography', 'safari', 'wildlife', 'tips']
  },
  {
    id: 7,
    title: 'Family-Friendly Safari Experiences in Kenya',
    slug: 'family-friendly-safari-experiences-kenya',
    excerpt: 'Plan the perfect family safari with our guide to kid-friendly lodges, age-appropriate activities, and educational wildlife experiences in Kenya.',
    content: 'Full article content here...',
    image: 'https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2071&q=80',
    author: {
      name: 'Sarah Njeri',
      avatar: 'https://randomuser.me/api/portraits/women/44.jpg'
    },
    date: '2024-09-15',
    category: 'Family',
    tags: ['family', 'kids', 'safari', 'activities']
  },
  {
    id: 8,
    title: 'Luxury Safari Lodges in Kenya',
    slug: 'luxury-safari-lodges-kenya',
    excerpt: 'Experience the height of safari luxury with our curated selection of Kenya\'s most exclusive lodges, offering unparalleled comfort and wildlife viewing.',
    content: 'Full article content here...',
    image: 'https://images.unsplash.com/photo-1493246507139-91e8fad9978e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80',
    author: {
      name: 'Elizabeth Wanjiku',
      avatar: 'https://randomuser.me/api/portraits/women/28.jpg'
    },
    date: '2024-09-05',
    category: 'Luxury',
    tags: ['luxury', 'lodges', 'accommodation', 'exclusive']
  }
];

const BlogPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState({
    category: searchParams.get('category') || '',
    search: searchParams.get('search') || '',
    page: parseInt(searchParams.get('page') || '1', 10)
  });
  
  const [filteredPosts, setFilteredPosts] = useState([]);
  const postsPerPage = 6;
  
  // Extract unique categories from blog posts
  const categories = [...new Set(sampleBlogPosts.map(post => post.category))];
  
  // Update URL when filters change
  useEffect(() => {
    const params = new URLSearchParams();
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value) {
        params.set(key, value);
      }
    });
    
    setSearchParams(params);
  }, [filters, setSearchParams]);
  
  // Filter and paginate posts
  useEffect(() => {
    let result = [...sampleBlogPosts];
    
    // Apply category filter
    if (filters.category) {
      result = result.filter(post => post.category === filters.category);
    }
    
    // Apply search filter
    if (filters.search) {
      const searchLower = filters.search.toLowerCase();
      result = result.filter(post => 
        post.title.toLowerCase().includes(searchLower) || 
        post.excerpt.toLowerCase().includes(searchLower) ||
        post.category.toLowerCase().includes(searchLower) ||
        post.tags.some(tag => tag.toLowerCase().includes(searchLower))
      );
    }
    
    setFilteredPosts(result);
  }, [filters]);
  
  // Calculate pagination
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);
  const startIndex = (filters.page - 1) * postsPerPage;
  const paginatedPosts = filteredPosts.slice(startIndex, startIndex + postsPerPage);
  
  // Handle search input
  const [searchInput, setSearchInput] = useState(filters.search);
  
  const handleSearch = (e) => {
    e.preventDefault();
    setFilters(prev => ({
      ...prev,
      search: searchInput,
      page: 1 // Reset to first page on new search
    }));
  };
  
  // Handle category change
  const handleCategoryChange = (category) => {
    setFilters(prev => ({
      ...prev,
      category,
      page: 1 // Reset to first page on category change
    }));
  };
  
  // Handle page change
  const handlePageChange = (page) => {
    setFilters(prev => ({
      ...prev,
      page
    }));
    
    // Scroll to top of page
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  
  // Generate SEO metadata for blog listing page
  const generateBlogListingSEO = () => {
    // Default title and description
    let title = 'Travel Blog - Tips, Insights & Stories';
    let description = 'Discover travel tips, wildlife insights, and adventure stories from our team of Kenya travel experts.';
    let keywords = ['travel blog', 'kenya travel', 'safari tips', 'wildlife', 'adventure', 'travel stories'];
    let canonicalUrl = `${defaultSEO.siteUrl}/blog`;
    
    // If category is selected, customize SEO data
    if (filters.category) {
      title = `${filters.category} Articles - Travel Blog`;
      description = `Explore our collection of ${filters.category.toLowerCase()} articles and travel stories. Expert tips and insights about ${filters.category.toLowerCase()} in Kenya.`;
      keywords = [`${filters.category.toLowerCase()}`, `${filters.category.toLowerCase()} travel`, `${filters.category.toLowerCase()} tips`, ...keywords];
      canonicalUrl = `${defaultSEO.siteUrl}/blog?category=${encodeURIComponent(filters.category)}`;
    }
    
    // If search term is present, customize title
    if (filters.search) {
      title = `Search Results for "${filters.search}" - Travel Blog`;
      description = `Articles and travel stories related to "${filters.search}". Find expert tips and insights about traveling in Kenya.`;
      keywords = [filters.search, ...keywords];
      canonicalUrl = `${defaultSEO.siteUrl}/blog?search=${encodeURIComponent(filters.search)}`;
    }
    
    // Add pagination info to canonical URL if not on first page
    if (filters.page > 1) {
      canonicalUrl += canonicalUrl.includes('?') ? '&' : '?';
      canonicalUrl += `page=${filters.page}`;
    }
    
    // Generate structured data for blog listing
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'Blog',
      headline: title,
      description: description,
      publisher: {
        '@type': 'Organization',
        name: defaultSEO.siteName,
        logo: {
          '@type': 'ImageObject',
          url: `${defaultSEO.siteUrl}/images/logo.png`
        }
      },
      url: canonicalUrl,
      blogPost: paginatedPosts.map(post => ({
        '@type': 'BlogPosting',
        headline: post.title,
        description: post.excerpt,
        datePublished: new Date(post.date).toISOString(),
        author: {
          '@type': 'Person',
          name: post.author.name
        },
        image: post.image,
        url: `${defaultSEO.siteUrl}/blog/${post.slug}`
      }))
    };
    
    return {
      title,
      description,
      keywords,
      canonicalUrl,
      ogType: 'website',
      ogImage: `${defaultSEO.siteUrl}/images/blog-banner.jpg`,
      structuredData
    };
  };
  
  // Get SEO data
  const blogListingSEO = generateBlogListingSEO();

  return (
    <div className="bg-gray-50">
      {/* SEO Head */}
      <SEOHead
        title={blogListingSEO.title}
        description={blogListingSEO.description}
        keywords={blogListingSEO.keywords}
        canonicalUrl={blogListingSEO.canonicalUrl}
        ogType={blogListingSEO.ogType}
        ogImage={blogListingSEO.ogImage}
        structuredData={blogListingSEO.structuredData}
      />
      {/* Hero Section */}
      <div className="relative bg-gray-900 text-white">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-30"
          style={{ 
            backgroundImage: `url('https://images.unsplash.com/photo-1516426122078-c23e76319801?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80')` 
          }}
        ></div>
        <div className="container-custom mx-auto py-20 relative z-10">
          <div className="max-w-3xl">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Travel Blog</h1>
            <p className="text-xl text-gray-200 mb-8">
              Discover travel tips, wildlife insights, and adventure stories from our team of Kenya travel experts.
            </p>
            
            {/* Search Form */}
            <form onSubmit={handleSearch} className="flex w-full max-w-lg">
              <input
                type="text"
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                placeholder="Search articles..."
                className="flex-grow px-4 py-3 rounded-l-md focus:outline-none"
              />
              <button
                type="submit"
                className="bg-primary hover:bg-primary-dark text-white px-4 py-3 rounded-r-md transition-colors"
              >
                <MagnifyingGlassIcon className="h-5 w-5" />
              </button>
            </form>
          </div>
        </div>
      </div>
      
      {/* Blog Content */}
      <div className="container-custom mx-auto py-16">
        {/* Categories */}
        <BlogCategories 
          categories={categories}
          selectedCategory={filters.category}
          onCategoryChange={handleCategoryChange}
        />
        
        {/* Results Info */}
        <div className="mb-8">
          <h2 className="text-2xl font-bold text-gray-800">
            {filters.category 
              ? `${filters.category} Articles` 
              : filters.search 
                ? `Search Results for "${filters.search}"` 
                : 'Latest Articles'
            }
          </h2>
          <p className="text-gray-600 mt-2">
            {filteredPosts.length} {filteredPosts.length === 1 ? 'article' : 'articles'} found
          </p>
        </div>
        
        {/* Blog Posts Grid */}
        {paginatedPosts.length > 0 ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            {paginatedPosts.map(post => (
              <BlogCard key={post.id} post={post} />
            ))}
          </div>
        ) : (
          <div className="bg-white rounded-lg shadow-md p-8 text-center mb-12">
            <h3 className="text-xl font-bold mb-2 text-gray-800">No articles found</h3>
            <p className="text-gray-600 mb-4">
              Try adjusting your search or filter criteria to find what you're looking for.
            </p>
            <button
              onClick={() => setFilters({ category: '', search: '', page: 1 })}
              className="bg-primary hover:bg-primary-dark text-white font-medium px-4 py-2 rounded-md transition-colors"
            >
              View All Articles
            </button>
          </div>
        )}
        
        {/* Pagination */}
        {totalPages > 1 && (
          <Pagination 
            currentPage={filters.page}
            totalPages={totalPages}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </div>
  );
};

export default BlogPage;
